import React, {Component} from 'react';
import '../App.css';
import data from '../data';
class MessagesComponent extends Component{
    componentDidUpdate() {
        this.newData.scrollIntoView({ behavior: "smooth" })
    }
    render(){
        return(
                <ul className="chatList mt-4 mr-1">
                {
                    this.props.messages.map(x => {
                        if(x.user === "time"){
                            return(
                            <li className="text-center">
                                {x.message}
                            </li>
                            )
                        }else if(x.user === "guest"){
                            return(
                            <li className="text-right">
                                <span className="guestLi">
                                    {x.message}
                                </span>
                                <i class="fas fa-user-circle fa-2x"></i>
                            </li>
                            )
                        }else{
                            return(
                                <li className="text-left">
                                    <img 
                                        src={data.Photo}
                                        height="35px"
                                    />
                                    <span className="meLi">
                                    <div dangerouslySetInnerHTML={{ __html: x.message   }}></div>
                                    </span>
                                </li>
                            )
                        }
                    })
                }
                <div ref={(ref) => this.newData = ref}  ></div>
                </ul>
            
        )
    }
}

export default MessagesComponent;